const rules = [
  {
    key: 'minimum-length',
    label: '8 characters minimum required',
    validate: (password: string) => password.length > 8,
  },
  {
    key: 'lowercase-letter',
    label: '1 lowercase letter',
    validate: (password: string) => password.toUpperCase() !== password,
  },
  {
    key: 'uppercase-letter',
    label: '1 uppercase letter',
    validate: (password: string) => password.toLowerCase() !== password,
  },
  {
    key: 'contains-number',
    label: '1 number (0-9)',
    validate: (password: string) => /\d+/g.test(password),
  },
  {
    key: 'special-character',
    label: '1 special character',
    validate: (password: string) =>
      /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g.test(password),
  },
];

export default rules;
